import script from "./BasketTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BasketTable.vue?vue&type=script&setup=true&lang=js"

import "./BasketTable.vue?vue&type=style&index=0&id=bb4828d2&scoped=true&lang=scss"
import "./BasketTable.vue?vue&type=style&index=1&id=bb4828d2&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb4828d2"]])

export default __exports__